export const LOGIN = '/login';
